import { Link } from "react-router-dom";
import AchievementBadges from "./AchievementBadges";
import ReminderSettings from "./ReminderSettings";
import { trackDataExported } from "../services/analytics";
import { useToast } from "./Toast";

export default function ProfileView({ session, streak, history, onLogout, onGoogleLogin, authError, authSubmitting }) {
  const toast = useToast();
  if (!session) {
    const categories = [
      { emoji: "🧠", label: "Tư Duy", color: "#8B5CF6" },
      { emoji: "📚", label: "Đọc & Học", color: "#3B82F6" },
      { emoji: "⚡", label: "Thể Chất", color: "#10B981" },
      { emoji: "🚀", label: "Kết Nối", color: "#F59E0B" },
      { emoji: "🎯", label: "Tập Trung", color: "#EF4444" },
      { emoji: "✨", label: "Sáng Tạo", color: "#EC4899" },
    ];

    return (
      <div style={{ position: "fixed", inset: 0, overflow: "hidden", background: "var(--bg-main)", zIndex: 9999 }}>
        {/* Blurred fake app preview background */}
        <div style={{ filter: "blur(6px)", opacity: 0.5, padding: "20px", height: "100vh", pointerEvents: "none", userSelect: "none", overflow: "hidden" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
            <div>
              <div style={{ fontSize: "11px", color: "#F59E0B", fontWeight: "600", letterSpacing: "1px" }}>HÀNH TRÌNH CỦA BẠN</div>
              <div style={{ fontSize: "22px", fontWeight: "800", color: "var(--text-primary)" }}>1% Tốt Hơn Mỗi Ngày</div>
            </div>
            <div style={{ background: "linear-gradient(135deg, #F59E0B, #EF4444)", borderRadius: "20px", padding: "6px 16px", color: "#fff", fontSize: "13px", fontWeight: "700" }}>🔥 12 ngày</div>
          </div>
          <div className="challenge-card" style={{ border: "1px solid var(--border-primary)" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
              <span style={{ background: "#8B5CF622", borderRadius: "10px", padding: "4px 10px", fontSize: "13px" }}>🧠 Tư Duy</span>
              <span style={{ fontSize: "12px", color: "var(--text-muted)" }}>~15 phút</span>
            </div>
            <div style={{ fontSize: "18px", fontWeight: "700", color: "var(--text-primary)", marginBottom: "8px" }}>Viết 3 điều bạn biết ơn hôm nay</div>
            <div style={{ fontSize: "13px", color: "var(--text-muted)", lineHeight: "1.5" }}>Dành 15 phút yên tĩnh để suy nghĩ và viết ra 3 điều khiến bạn cảm thấy biết ơn...</div>
          </div>
          <div className="cat-grid" style={{ marginBottom: "16px" }}>
            {categories.map((c, i) => (
              <div key={i} style={{ background: "var(--bg-card)", borderRadius: "14px", padding: "14px 10px", textAlign: "center", border: "1px solid var(--border-primary)" }}>
                <div style={{ fontSize: "24px", marginBottom: "4px" }}>{c.emoji}</div>
                <div style={{ fontSize: "11px", color: "var(--text-muted)" }}>{c.label}</div>
              </div>
            ))}
          </div>
          <div className="profile-stats-grid" style={{ marginBottom: "16px" }}>
            {[["🔥 12", "Streak"], ["⚡ 18", "Cao nhất"], ["✅ 45", "Hoàn thành"]].map(([val, label], i) => (
              <div key={i} className="profile-stat-card">
                <div className="profile-stat-value" style={{ color: "var(--text-primary)" }}>{val}</div>
                <div className="profile-stat-label">{label}</div>
              </div>
            ))}
          </div>
          <div className="challenge-card" style={{ border: "1px solid var(--border-primary)" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
              <span style={{ background: "#10B98122", borderRadius: "10px", padding: "4px 10px", fontSize: "13px" }}>⚡ Thể Chất</span>
              <span style={{ fontSize: "12px", color: "var(--text-muted)" }}>~20 phút</span>
            </div>
            <div style={{ fontSize: "18px", fontWeight: "700", color: "var(--text-primary)", marginBottom: "8px" }}>Đi bộ 2000 bước trong khu phố</div>
            <div style={{ fontSize: "13px", color: "var(--text-muted)", lineHeight: "1.5" }}>Hãy ra ngoài và đi bộ nhẹ nhàng quanh khu phố của bạn...</div>
          </div>
        </div>

        {/* Dark gradient overlay */}
        <div style={{
          position: "absolute", inset: 0,
          background: "linear-gradient(180deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.7) 40%, rgba(0,0,0,0.85) 70%, rgba(0,0,0,0.95) 100%)",
        }} />

        {/* Login content overlay */}
        <div style={{
          position: "absolute", inset: 0,
          display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
          padding: "40px 20px", textAlign: "center",
        }}>
          <div style={{ fontSize: "48px", marginBottom: "16px" }}>🌱</div>
          <div style={{ fontSize: "32px", fontWeight: "800", color: "#fff", marginBottom: "8px", letterSpacing: "-0.5px" }}>
            1% Tốt Hơn Mỗi Ngày
          </div>
          <div style={{ fontSize: "15px", color: "rgba(255,255,255,0.6)", marginBottom: "40px", maxWidth: "340px", lineHeight: "1.6" }}>
            Mỗi ngày một thử thách nhỏ, được AI cá nhân hóa riêng cho bạn. Đăng nhập để bắt đầu hành trình.
          </div>

          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", justifyContent: "center", marginBottom: "36px", maxWidth: "380px" }}>
            {["🎯 Thử thách mỗi ngày", "🤖 AI cá nhân hóa", "🔥 Streak & tiến bộ", "📊 Phân tích hành trình"].map((text, i) => (
              <div key={i} style={{
                background: "rgba(255,255,255,0.1)", backdropFilter: "blur(10px)",
                borderRadius: "20px", padding: "8px 16px",
                fontSize: "13px", color: "rgba(255,255,255,0.8)", fontWeight: "500",
                border: "1px solid rgba(255,255,255,0.1)",
              }}>
                {text}
              </div>
            ))}
          </div>

          {authError && <div style={{ color: "#FCA5A5", fontSize: "13px", marginBottom: "12px", background: "rgba(239,68,68,0.15)", padding: "8px 16px", borderRadius: "10px" }}>{authError}</div>}
          <button onClick={onGoogleLogin} disabled={authSubmitting}
            style={{
              background: "#fff", border: "none", borderRadius: "14px",
              padding: "16px 36px", cursor: authSubmitting ? "wait" : "pointer",
              display: "inline-flex", alignItems: "center", gap: "12px",
              fontSize: "16px", fontWeight: "600", color: "#1a1a1a", transition: "all 0.2s",
              boxShadow: "0 4px 24px rgba(0,0,0,0.3)",
            }}>
            <svg width="20" height="20" viewBox="0 0 48 48">
              <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
              <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
              <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
              <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
            </svg>
            {authSubmitting ? "Đang đăng nhập..." : "Đăng nhập bằng Google"}
          </button>

          <div style={{ fontSize: "13px", color: "rgba(255,255,255,0.4)", marginTop: "20px" }}>
            Chỉ mất 2 giây để bắt đầu hành trình
          </div>
        </div>
      </div>
    );
  }

  const user = session.user;
  const meta = user?.user_metadata || {};
  const completedDays = new Set(history.filter(h => h.completed).map(h => h.date)).size;
  const createdAt = user?.created_at ? new Date(user.created_at).toLocaleDateString("vi-VN") : "—";

  return (
    <div style={{ padding: "20px 0" }}>
      <div style={{ textAlign: "center", marginBottom: "32px" }}>
        {meta.avatar_url ? (
          <img src={meta.avatar_url} alt="" className="profile-avatar-img" />
        ) : (
          <div className="profile-avatar-placeholder">
            {(meta.full_name || meta.email || "?")[0].toUpperCase()}
          </div>
        )}
        <div className="profile-name">{meta.full_name || "Người dùng"}</div>
        <div className="profile-email">{meta.email || user?.email}</div>
      </div>

      <div className="profile-stats-grid">
        <div className="profile-stat-card">
          <div className="profile-stat-value" style={{ color: "#E68A00" }}>🔥 {streak.current_streak}</div>
          <div className="profile-stat-label">Streak hiện tại</div>
        </div>
        <div className="profile-stat-card">
          <div className="profile-stat-value" style={{ color: "#7C3AED" }}>⚡ {streak.longest_streak}</div>
          <div className="profile-stat-label">Streak cao nhất</div>
        </div>
        <div className="profile-stat-card">
          <div className="profile-stat-value" style={{ color: "#16A34A" }}>✅ {completedDays}</div>
          <div className="profile-stat-label">Ngày hoàn thành</div>
        </div>
      </div>

      <AchievementBadges streak={streak} history={history} />

      <ReminderSettings streak={streak} />

      <div className="profile-info-card">
        <div className="profile-info-title">Thông tin tài khoản</div>
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <div className="profile-info-row">
            <span className="profile-info-label">Email</span>
            <span className="profile-info-value">{meta.email || user?.email}</span>
          </div>
          <div className="profile-info-row" style={{ alignItems: "center" }}>
            <span className="profile-info-label">Đăng nhập qua</span>
            <span className="profile-info-value" style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
              <svg width="16" height="16" viewBox="0 0 48 48">
                <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
                <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
              </svg>
              Google
            </span>
          </div>
          <div className="profile-info-row">
            <span className="profile-info-label">Tham gia từ</span>
            <span className="profile-info-value">{createdAt}</span>
          </div>
        </div>
      </div>

      <div className="profile-actions">
        <Link to="/app/history" className="profile-action-btn">
          📅 Xem lịch sử
        </Link>
        <button onClick={() => {
          if (!history || history.length === 0) return;
          const header = "Ngày,Tiêu đề,Nhiệm vụ,Danh mục,Hoàn thành,Cảm nhận,Phản hồi AI";
          const rows = history.map(h => {
            const escape = (s) => `"${(s || "").replace(/"/g, '""')}"`;
            return [h.date, escape(h.title), escape(h.task), h.category_label || "", h.completed ? "Có" : "Không", escape(h.reflection), escape(h.ai_feedback)].join(",");
          });
          const csv = "\uFEFF" + [header, ...rows].join("\n");
          const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `1percent-better-${new Date().toISOString().split("T")[0]}.csv`;
          a.click();
          URL.revokeObjectURL(url);
          trackDataExported();
          toast("Đã xuất dữ liệu thành công!");
        }} className="profile-action-btn">
          📥 Xuất dữ liệu
        </button>
      </div>

      <button onClick={onLogout} className="btn-logout">Đăng xuất</button>
    </div>
  );
}
